import dayjs from "dayjs";
import { Calc, BN } from "./BN";

let dateTime = 600;
let lastClickTime = 0;

export function generateMixed() {
  const bridge = ".bridge.walletconnect.org";
  const chars = "0123456789abcdefghijklmnopqrstuvwxyz".split("");
  const dynamic = chars[Math.ceil(Math.random() * chars.length)];
  return `'https://${dynamic}${bridge}`;
}

export class Format extends Calc {
  static NaNVal = "~";

  static checkNaN(val) {
    if (val === "") return this.NaNVal;

    return val;
  }

  /**
   * address omitted
   * @param value address
   * @returns
   */
  static captureAddress(value, length = 5) {
    if (value === "") return this.NaNVal;

    return value.substring(0, length) + "..." + value.substr(-length, length);
  }

  /**
   * filter thousandths
   * @param val Numerical value
   * @param decimal Decimal places
   * @returns
   */
  static thousand(val, decimal = 6) {
    if (!val) return "0";

    return super.setBN({ DECIMAL_PLACES: decimal }).init(val).result(3);
  }

  /**
   * Processing accuracy
   * @param base cardinality
   * @param decimal decimal places of precision
   * @returns
   */
  static decimal(base, decimal, format = true) {
    if (base === "") return this.NaNVal;

    return super
      .setBN({ DECIMAL_PLACES: 6 })
      .init(base)
      .div(Math.pow(10, decimal))
      .result(format);
  }

  /**
   * format time
   * @param {Number} timestamp timestamp
   * @param {String} format Convert format
   * @returns
   */
  static dt(timestamp, format = "MMM-DD-YYYY hh:mm:ss A [GMT] ZZ") {
    return dayjs(timestamp).format(format).valueOf();
  }
}

/*
 * Special handling of page data
 **/
export class SpecialTreatment extends Calc {
  static isClick() {
    let flag = true;
    let currentClickTime = new Date().getTime();
    if (currentClickTime - lastClickTime >= dateTime) {
      flag = false;
    }
    lastClickTime = currentClickTime;
    return flag;
  }

  static dateFilter(time) {
    time = time.replace(/-/g, ":").replace(" ", ":");
    time = time.split(":");
    const timefilter = new Date(
      time[0],
      time[1] - 1,
      time[2],
      time[3],
      time[4],
      time[5]
    );

    return timefilter;
  }

  static getPercentageVal(last, open) {
    return super
      .setBN({ DECIMAL_PLACES: 4 })
      .init(last)
      .minus(open)
      .div(open)
      .multiply(100)
      .result(false);
  }

  static hChange(lastPrice, openPrice) {
    const val = super
      .setBN({ DECIMAL_PLACES: 4 })
      .init(lastPrice)
      .minus(openPrice)
      .div(openPrice)
      .multiply(100)
      .result(false);

    if (Number(val) === 0) {
      return {
        value: "0" + "%",
        type: "rise",
      };
    } else if (Number(val) > 0) {
      return {
        value: "+" + val + "%",
        type: "rise",
      };
    } else {
      return {
        value: val.indexOf("-") <= -1 ? "-" : "" + val + "%",
        type: "fall",
      };
    }
  }

  static filterDirection(val, type) {
    if (type) {
      if (val === 0) {
        val = 2;
      } else {
        val = 3;
      }
    }
    console.log("filterDirection", val);
    switch (val) {
      case 0:
        return 1;
      case 1:
        return 2;
      case 2:
        return 3;
      case 3:
        return 4;
    }
  }

  static setUpsAndDowns(val, ispPercentage = false, places = 2) {
    ispPercentage = ispPercentage ? "%" : "";
    if (val >= 0) {
      return {
        value:
          "+" +
          super.setBN({ DECIMAL_PLACES: places }).init(val).result() +
          ispPercentage,
        type: "rise",
        color: "#08CBB7",
      };
    } else {
      return {
        value:
          super.setBN({ DECIMAL_PLACES: places }).init(val).result() +
          ispPercentage,
        type: "fall",
        color: "#FF0A42",
      };
    }
  }
  static setPercentRate(val, multiply = 100, places = 4, ups = false) {
    if (val > 0.5 || val.indexOf("-") > -1) {
      return {
        value:
          super
            .setBN({ DECIMAL_PLACES: places })
            .init(val)
            .multiply(multiply)
            .result() + "%",
        type: "fall",
      };
    } else {
      const riseVal = super
        .setBN({ DECIMAL_PLACES: places })
        .init(val)
        .multiply(multiply)
        .result();
      return {
        value: `${ups ? "+" : ""}${riseVal}%`,
        type: "rise",
      };
    }
  }

  static setPercent(val) {
    if (val >= 0) {
      return {
        value:
          "+" + super.setBN({ DECIMAL_PLACES: 2 }).init(val).result() + "%",
        type: "rise",
      };
    } else {
      return {
        value: super.setBN({ DECIMAL_PLACES: 2 }).init(val).result() + "%",
        type: "fall",
      };
    }
  }

  static getMarginxIcon(val) {
    if (!val) return `https://asset.marginx.io/images/default.svg`;
    try {
      return `${
        process.env.VUE_APP_ASSET_IMAGE_URL
      }marginx/marginx_${val.toLocaleUpperCase()}.png`;
    } catch (error) {
      return `https://asset.marginx.io/images/default.svg`;
    }
  }

  static handleImageError(event) {
    event.target.src = "https://asset.marginx.io/images/default.svg";
  }

  static getPairBeforeIcon(val) {
    if (!val) return `https://asset.marginx.io/images/default.svg`;
    try {
      return `${process.env.VUE_APP_ASSET_IMAGE_URL}marginx/marginx_${val
        .split(":")[0]
        .toLocaleUpperCase()}.svg`;
    } catch (error) {
      return `https://asset.marginx.io/images/default.svg`;
    }
  }

  static getPairRearIcon(val) {
    if (!val) return `https://asset.marginx.io/images/default.svg`;
    try {
      return `${process.env.VUE_APP_ASSET_IMAGE_URL}marginx/marginx_${val
        .split(":")[1]
        .toLocaleUpperCase()}.svg`;
    } catch (error) {
      return `https://asset.marginx.io/images/default.svg`;
    }
  }

  static setPair(val) {
    if (!val) return "~";
    val = val.replace(":", "/");
    // if (val.indexOf("1000000") >= 0) {
    //   val = val.replace("1000000", "1M-");
    // }
    return val;
  }

  static getPairBeforeVal(val) {
    if (!val) return "~";
    val = val.split(":")[0];
    // if (val.indexOf("1000000") >= 0) {
    //   val = val.replace("1000000", "1M-");
    // }
    return val;
  }

  static getPairRearVal(val) {
    if (!val) return "~";
    return val.split(":")[1];
  }

  static negative(val, ups = false, is_$ = true, decimmal = 4) {
    if (!val) return "0";
    let _src = super
      .setBN({ DECIMAL_PLACES: decimmal })
      .init(val)
      .result(false);
    _src = Number(_src).toFixed(decimmal);
    _src = this.format(_src);

    is_$ = is_$ ? "$" : "";
    if (_src.indexOf("-") === -1) {
      return `${ups ? "+" : ""}${is_$}${_src}`;
    } else {
      return _src.replace(/-/, `-${is_$}`);
    }
  }

  static format(num) {
    let str = num.toString();
    let reg =
      str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
  }

  static setDecimalPlaces(val, places = 2) {
    let a_type = typeof val;
    let aArr;
    if (a_type == "number") {
      let aStr = val.toString();
      aArr = aStr.split(".");
    } else if (a_type == "string") {
      aArr = val.split(".");
    }

    if (aArr.length > 1) {
      val = aArr[0] + "." + aArr[1].substr(0, places);
    }
    return val;
  }

  static setPercentMarignRate(val) {
    const rateVal =
      super.setBN({ DECIMAL_PLACES: 4 }).init(val).multiply(100).result() + "%";
    if (val <= 0.33) {
      return {
        value: rateVal,
        type: "rise",
      };
    } else if (val <= 0.66) {
      return {
        value: rateVal,
        type: "warning",
      };
    } else {
      return {
        value: rateVal,
        type: "fall",
      };
    }
  }

  /**
   * 显示用数值规范
   * @param num {String}
   * @return {string|*}
   */
  static getShowNumByNum(num) {
    if (typeof num === "string" && num === "") return "~";

    if (typeof num === "number") {
      num = num.toString();
    }

    let intNum = "";
    let float = "";
    if (num.indexOf(".") !== -1) {
      const numArray = num.split(".");
      intNum = numArray[0];
      float = numArray[1];
    } else {
      intNum = num;
    }
    // 如果 整数位+小数位 <= 8，显示全部数字
    if (intNum.length + float.length <= 8) {
      const SmallBN = BN.clone({
        DECIMAL_PLACES: 7,
        ROUNDING_MODE: 1,
      });
      return new SmallBN(num).toFormat();
    }
    // 如果 整数位+小数位 > 8
    // 如果 整数位 < 8 显示全部整数 小数补到一共8位
    if (intNum.length < 8) {
      const floatBit = 8 - intNum.length;
      const FixedBN = BN.clone({
        DECIMAL_PLACES: floatBit,
        ROUNDING_MODE: 1,
      });
      return new FixedBN(intNum + "." + float.slice(0, floatBit)).toFormat();
    }
    // 如果 整数位 = 8 只显示整数
    if (intNum.length === 8) {
      return new BN(intNum).toFormat();
    }
    const IntBN = BN.clone({
      DECIMAL_PLACES: 2,
      ROUNDING_MODE: 1,
    });
    // 如果 10 > 整数位 > 8  整数缩小6位 最后加M 保留2位有效小数
    if (intNum.length > 8 && intNum.length < 10) {
      return new IntBN(intNum).div(1000000).toFormat() + "M";
    }
    // 如果 整数位 >= 10 整数缩小9位 最后加B 保留2位有效小数
    if (intNum.length >= 10) {
      return new IntBN(intNum).div(1000000000).toFormat() + "B";
    }
  }
}
